// extracted by mini-css-extract-plugin
export default {"ImgButton":"imgButton_ImgButton__9wDrY"};